export class Controller {

    /** @ngInject */
    constructor($rootScope, $state) {
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
	this.goToState = this.$rootScope.transition.from();
	this.goToStateParams = this.$rootScope.transition.params('from');
	this.theState = this.goToState.name;
		if (this.theState === "") {
			if(this.defaultBack){
				this.theState=this.defaultBack;
			} else {
				this.theState = this.goToState.url;
			}
			this.simpleBack=this.theState;
		} else {
			this.breadcrumb = this.$rootScope.breadcrumbHistory.reverse()
            .find((breadcrumb) => breadcrumb.name==this.theState);
		}
    }
    
    goBack() {
		if(this.simpleBack && this.reloadSimpleBack){
			this.$state.go(this.theState, this.goToStateParams, {reload: this.theState});
		} else {
			this.$state.go(this.theState,this.goToStateParams);
		}
		
	}
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-back/sp-back.controller.js